import { render, staticRenderFns } from "./listClientsBasicSearch.vue?vue&type=template&id=2b8803a2&scoped=true&"
import script from "./listClientsBasicSearch.vue?vue&type=script&lang=js&"
export * from "./listClientsBasicSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8803a2",
  null
  
)

export default component.exports